/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {AgeCategory} from "./AgeCategory";
import {EntryCategory} from "./EntryCategory";
import {EntryClassification} from "./EntryClassification";
import {EntryType} from "./EntryType";
import {FixedTime} from "./FixedTime";
import {EntryMedallion} from "./EntryMedallion";
import {AwardType} from "./AwardType";


export class CompetitionMetadata {

  private static AGE_CATEGORIES: string = 'ageCategories';
  private static CATEGORIES: string = 'categories';
  private static CLASSIFICATIONS: string = 'classifications';
  private static ENTRY_TYPES: string = 'entryTypes';
  private static FIXED_TIME: string = 'fixedTime';
  private static MEDALLIONS: string = 'medallions';
  private static AWARD_TYPES: string = 'awardTypes';

  constructor(public ageCategories: Array<AgeCategory> = [],
              public categories: Array<EntryCategory> = [],
              public classifications: Array<EntryClassification> = [],
              public entryTypes: Array<EntryType> = [],
              public fixedTimes: Array<FixedTime> = [],
              public medallions: Array<EntryMedallion> = [],
              public awardTypes: Array<AwardType> = []) {

  }

  getAgeCategoryById(id: string) : AgeCategory {
    if (id) {
      return this.ageCategories.filter(x => x.id == id)[0];
    }
    return null;
  }

  getCategoryById(id: string) : EntryCategory {
    if (id) {
      return this.categories.filter(x => x.id == id)[0];
    }
    return null;
  }

  getClassficationById(id: string) : EntryClassification {
    if (id) {
      return this.classifications.filter(x => x.id == id)[0];
    }
    return null;
  }

  getEntryTypeById(id: string) : EntryType {
    if (id) {
      return this.entryTypes.filter(x => x.id == id)[0];
    }
    return null;
  }

  getFixedTimeById(id: string) : FixedTime {
    if (id) {
      return this.fixedTimes.filter(x => x.id == id)[0];
    }
    return null;
  }

  getMedallionById(id: string) : EntryMedallion {
    if (id) {
      return this.medallions.filter(x => x.id == id)[0];
    }
    return null;
  }

  getMedallionForScore(score: number = -1) {
    if (score < 0) {
      return null;
    }

    const roundedScore = Math.round(score);
    let medals = this.medallions.filter(m => roundedScore <= m.maxScore && roundedScore >= m.minScore);
    if (medals.length > 0) {
      return Object.assign({}, medals[0]);
    } else {
      return null;
    }
  }

  static fromSnapshot(snapshot: any) : CompetitionMetadata {
    // console.log(snapshot.val());
    return CompetitionMetadata._fromSnapshot(snapshot.val())
  }

  private static _fromSnapshot(val: any) : CompetitionMetadata {
    let keys = Object.keys(val);
    // console.log(keys);

    let ageCategories: Array<AgeCategory>;
    let categories: Array<EntryCategory>;
    let classifications: Array<EntryClassification>;
    let entryTypes: Array<EntryType>;
    let fixedTimes: Array<FixedTime>;
    let medallions: Array<EntryMedallion>;
    let awardTypes: Array<AwardType>;

    for (let key of keys) {
      switch (key) {
        case CompetitionMetadata.AGE_CATEGORIES:
          ageCategories = AgeCategory.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.CATEGORIES:
          categories = EntryCategory.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.CLASSIFICATIONS:
          classifications = EntryClassification.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.ENTRY_TYPES:
          entryTypes = EntryType.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.FIXED_TIME:
          fixedTimes = FixedTime.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.MEDALLIONS:
          medallions = EntryMedallion.listFromSnapshot(key, val[key]);
          break;
        case CompetitionMetadata.AWARD_TYPES:
          awardTypes = AwardType.listFromSnapshot(key, val[key]);
          break;
        default:
          console.warn('Not implemented: ' + key);
          break;
      }
    }

    // console.log(entryTypes);

    return new CompetitionMetadata(ageCategories, categories, classifications, entryTypes, fixedTimes, medallions, awardTypes);
  }
}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/CompetitionMetadata.ts